var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1324 17.9718C17.9027 18.2014 17.5418 18.3327 17.1481 18.3327C16.7544 18.3327 16.4263 18.2014 16.1639 17.9718L13.1455 14.9534L12.8502 15.1175C11.7676 15.708 10.5864 16.0361 9.37254 16.0361C5.40272 16.0361 2.1875 12.8209 2.1875 8.85105C2.1875 4.88124 5.40272 1.66602 9.37254 1.66602C13.3424 1.66602 16.5576 4.88124 16.5576 8.85105C16.5576 10.2618 16.1639 11.607 15.3765 12.7881L15.1796 13.1161L18.1652 16.1017C18.3948 16.3642 18.5589 16.6923 18.5589 17.0532C18.5261 17.3812 18.3948 17.7093 18.1324 17.9718ZM9.37262 4.02822C6.71514 4.02822 4.58259 6.19357 4.58259 8.81824C4.58259 11.4757 6.74794 13.6083 9.37262 13.6083C12.0301 13.6083 14.1626 11.4429 14.1626 8.81824C14.1626 6.19357 12.0301 4.02822 9.37262 4.02822Z",
    fill: "currentColor",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.96d74b659a0fc78e72058bc54bddae1b.svg";
export { ForwardRef as ReactComponent };